import { render, staticRenderFns } from "./ConfirmDeleteProvider.vue?vue&type=template&id=634691e0&scoped=true&"
import script from "./ConfirmDeleteProvider.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmDeleteProvider.vue?vue&type=style&index=0&id=634691e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634691e0",
  null
  
)

export default component.exports